import type { Tab } from "features/types/tabs";
import { Box } from "prism-react";

import { SetupTasks } from "./SetupTasks/SetupTasks";
import { DevtoolWrapper } from "./common/DevtoolWrapper";
import type { TabPanelProps } from "./types";

export const SetupTasksDevTool: React.FC<TabPanelProps<Tab>> = ({ tab }) => {
  return (
    <DevtoolWrapper variant="setup">
      <Box
        css={{
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <SetupTasks tab={tab} />
      </Box>
    </DevtoolWrapper>
  );
};
